import { useEffect, useState } from "react";
import "./InputCheckbox.scss";
export const InputCheckbox = ({ label, name, handleInputChange, value, disabled }) => {
  const [checkedValue, setCheckedValue] = useState(false);
  // console.log(value, "Hiii", name);
  useEffect(() => {
    setCheckedValue(value);
  }, [value]);
  // useEffect(() => {
  //   if (value === "") {
  //     setCheckedValue(false);
  //     handleInputChange({
  //       target: {
  //         name: name,
  //         value: false,
  //         checked: false,
  //       },
  //     });
  //   }
  // }, [value]);
  const formikdatamanage = (event) => {
    handleInputChange({
      target: {
        name: name,
        value: event.target.checked,
      },
    });
  };

  const handleChange = (event) => {
    // console.log(event, "isFirstLoadisFirstLoadisFirstLoadisFirstLoad");
    setCheckedValue(event.target.checked);
    formikdatamanage(event);
  };
  return (
    <>
      <div className="checkboxDiv" key={name}>
        <p className={`form__label-checkbox`}>{label}</p>
        <input
          name={name}
          onChange={handleChange}
          type="checkbox"
          className="inputcheckboxcss"
          checked={checkedValue || false}
          disabled={disabled}
        />
      </div>
    </>
  );
};
